import type { ReactNode } from "react";
import { createContext, useContext, useRef } from "react";
import { GameTheme } from "@/components/game/theme/GameTheme.js";
import type { GameThemeType } from "@rosette/ts/src/business/game/theme/GameThemeType.js";
import { useAssetLoader } from "@/components/assets/AssetContext.js";


const GameThemeContext = createContext<GameTheme | null>(null);

export function useGameTheme(): GameTheme {
    const gameTheme = useContext(GameThemeContext);
    if (gameTheme === null)
        throw new Error("Missing game theme!");

    return gameTheme;
}


interface GameThemeProviderProps {
    children: ReactNode;
    themeType: GameThemeType;
}

export function GameThemeProvider({ children, themeType }: GameThemeProviderProps) {
    const assetLoader = useAssetLoader();
    const themeRef = useRef<GameTheme | null>(null);
    if (themeRef.current === null || themeRef.current.getThemeType() != themeType) {
        themeRef.current = GameTheme.create(themeType, assetLoader);
    }
    return (
        <GameThemeContext.Provider value={themeRef.current}>
            {children}
        </GameThemeContext.Provider>
    );
}
